import { gsap } from 'gsap'

export const createScrollAnimation = async (
  items: HTMLElement[],
  el: HTMLElement,
  fromVars: gsap.TweenVars,
  toVars: gsap.TweenVars,
  staggerDelay: number,
  immediate: boolean,
  startOffset: number = 85,
  endOffset?: number
) => {
  if (!el || items.length === 0) {
    return
  }

  // Both ends are anchored to the ELEMENT'S TOP crossing a fixed band of the viewport
  // (start% near the bottom → end% around the upper-middle). This is deliberately
  // independent of element height: the old `end: 'bottom bottom'` made the scrub span
  // ≈ the element's own height, so a short heading or a one-row logo strip revealed in a
  // tiny sliver crammed against the very bottom of the screen — you'd see neither the
  // entrance nor (on scroll-up) the reverse. A fixed top%→top% band instead plays the
  // whole reveal while the element sits centrally in view, so it animates in on the way
  // down AND visibly reverses on the way up, for tall and short sections alike.
  //
  // clamp() pins both resolved positions inside the page's scroll range, so the first
  // section (right below a full-viewport hero, whose start would otherwise be a negative
  // scroll) and the last section (whose end would otherwise sit past max-scroll) both
  // still reach progress 0 and 1 — i.e. they fully reverse instead of sticking.
  const startPos = `clamp(top ${startOffset}%)`
  const endPos = `clamp(top ${endOffset ?? 45}%)`

  // Make the container visible, and the children will appear with their own animations.
  await gsap.set(el, { opacity: 1 })

  // Set child items to their initial state.
  await gsap.set(items, fromVars)

  if (immediate) {
    // All items animate together with stagger
    await gsap.fromTo(items, fromVars, {
      ...toVars,
      stagger: staggerDelay,
      scrollTrigger: {
        trigger: el,
        start: startPos,
        end: endPos,
        scrub: true
      }
    })
  } else {
    // Each item animates individually when it enters viewport
    items.forEach(item => {
      gsap.fromTo(item, fromVars, {
        ...toVars,
        scrollTrigger: {
          trigger: item,
          start: startPos,
          end: endPos,
          scrub: true
        }
      })
    })
  }
}
